import { render, staticRenderFns } from "./KoioteSelector.vue?vue&type=template&id=351b91d2&lang=es&"
import script from "./KoioteSelector.vue?vue&type=script&lang=js&"
export * from "./KoioteSelector.vue?vue&type=script&lang=js&"
import style0 from "./KoioteSelector.vue?vue&type=style&index=0&id=351b91d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports